import { getPublicRestClient, getRestClient } from "../client";
import { CustomerCommunicationSearch, OrderResponse } from "../graphql/generated/generated";
export interface CreateOrderInput {
  payload: string;
  payment: string;
  currency: string;
  webhookUrl?: string;
  shippingClassification: string;
  destination: {
    name: string;
    company: string;
    address1: string;
    address2: string;
    address3: string;
    city: string;
    state: string;
    postal: string;
    country: string;
    phone: string;
    email: string;
  };
  orderItems: Array<{
    sku: string;
    quantity: number;
    retailPrice: string;
    itemDescription: string;
    product: {
      coverUrl: string;
      gutsUrl: string;
      pageCount: string | number;
    };
  }>;
}

export interface CreateOrderResponse {
  customerOrderId: string;
  statusCode: number;
  statusDescription: string;
}

export const exportCommunicationsCSV = async (body: CustomerCommunicationSearch, authHeader: string) => {
  return getPublicRestClient().post<Blob>("/internal/openapi-backend/admin/export/customerCommunications", body, {
    headers: {
      Authorization: authHeader,
    },
    responseType: "blob",
  });
};

export const createOrder = async (body: CreateOrderInput, authHeader: string) => {
  return getRestClient().post<CreateOrderResponse>("/orders/create", body, {
    headers: {
      Authorization: authHeader,
    },
  });
};

export const getOrderById = async (customerOrderId: string, authHeader: string) => {
  return getRestClient().get<Omit<OrderResponse, "__typename">>("/orders/" + customerOrderId, {
    headers: {
      Authorization: authHeader,
    },
  });
};

export interface PriceListInfo {
  products: Array<{
    name: string;
    basePriceUsd: number;
    pageCostUsd: number;
    openapiSku: string;
    minPageCount: number;
  }>;
  shipping: Array<{
    quantityTierName: string;
    shippingOptions: Array<{
      classification: string;
      price: number;
    }>;
  }>;
}

export const getPriceListInfo = async () => {
  return getPublicRestClient().get<PriceListInfo>("/pricelistInfo");
};

export interface ShareIdeaRequest {
  contactEmail: string;
  contactName: string;
  message: string;
}

export interface SharedIdeaResponse {
  message: string;
  submittedMessage: string;
}

export const createShareIdea = async (request: ShareIdeaRequest) => {
  return getPublicRestClient().post<SharedIdeaResponse>("/shareAnIdea", request);
};

export interface ProductListingResponse {
  sizes: Record<
    string,
    Array<{
      index: number;
      inches: string;
      centimeters: string;
      price_key: string;
    }>
  >;
  covers: Array<{
    index: number;
    name: string;
    description_lines: Array<string>;
    price_key: string;
  }>;
  papers: Array<{
    index: number;
    name: string;
    description_lines: Array<string>;
    price_key: string;
  }>;
}

const productListing = {
  sizes: {
    square: [
      { index: 1, inches: "12x12in", centimeters: "30.4x30.4 cm", price_key: "12x12" },
      { index: 2, inches: "8x8in", centimeters: "20x20 cm", price_key: "8x8" },
    ],
    portrait_only: [{ index: 1, inches: "8x10in", centimeters: "20x25 cm", price_key: "8x10" }],
    portrait_and_landscape: [
      { index: 1, inches: "8.5x11in", centimeters: "21.6x28 cm", price_key: "8.5x11" },
      { index: 2, inches: "11x8.5in", centimeters: "28x21.6 cm", price_key: "11x8.5" },
    ],
  },
  covers: [
    {
      index: 1,
      name: "Matte ImageWrap cover",
      description_lines: ["Durable matte finish", "Wrap an image across the front cover, back cover, and spine"],
      price_key: "MAT",
    },
    {
      index: 2,
      name: "Gloss ImageWrap cover",
      description_lines: ["Durable gloss finish", "Wrap an image across the front cover, back cover, and spine"],
      price_key: "GLS",
    },
    {
      index: 3,
      name: "Gloss Soft cover",
      description_lines: ["Gloss finish", "Print on the front cover, back cover, and spine"],
      price_key: "SC",
    },
  ],
  papers: [
    {
      index: 1,
      name: "Premium Gloss",
      description_lines: ["Smooth gloss finish", "100# (148 gsm)", "Up to 380 pages"],
      price_key: "GL100T",
    },
  ],
};

export const getProductListing = async (): Promise<ProductListingResponse> => {
  return productListing;
};
